import { clsx } from 'clsx'
import { IconButton } from 'component/Button/IconButton'
import { Glass } from 'component/Glass'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ErrorPopover } from 'page/ProfileScreen/ErrorPopover/ErrorPopover'
import { Blank } from 'page/ProfileScreen/Selfies/Blank'
import { Photo } from 'page/ProfileScreen/Selfies/Photo'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './Selfie.module.scss'

type Props = {
  num: 0 | 1
}

export const Selfie = observer(({ num }: Props) => {
  const { selfies } = store.profile.common
  const selfie = selfies[num]
  const { src, url, err } = selfie
  const className = clsx(css.selfie, err && css.error)

  const onDelete = useLatestCallback(() => {
    selfie.clear()
  })

  const onOpenBanner = useLatestCallback(() => {
    store.profile.common.num = num
    controller.openSelfieBanner()
  })

  return <Glass>
    <Space wide tall>
      <Space center className={className} onClick={onOpenBanner}>
        {src ? <Photo selfie={selfie} /> : <Blank />}
      </Space>
      <ErrorPopover selfie={selfie} />
    </Space>
    {url && <Space className={css.pin}>
      <IconButton small={!opt.tsum} action={onDelete}>
        <Icon name="delete" />
      </IconButton>
    </Space>}
  </Glass>
})
